import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net'; 
import swal from 'sweetalert';
import { ProtectAPi } from '../../../../api/ProtectAPi';
import { SetPermission } from '../../../../auth/SetPermission';

const AppoinmentList = () => {

      
  const { http } = ProtectAPi();
  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const userPermission = SetPermission();

  useEffect(() => {
    http.get('/get-pages-appoinment-pending-list')
      .then(res => { 
        setTableData(res.data);
      })
      .catch(error => {
        console.error('Error fetching users:', error);
      });
  }, []);

  
  useEffect(() => {
      if (tableData.length > 0 && !tableRef.current.DataTable) {
          $(tableRef.current).DataTable();
      } else {
          if ($.fn.DataTable.isDataTable('#table-1')) {
              $(tableRef.current).DataTable().destroy();
          }
      }
  }, [tableData]);


  // delete roles
  const handleDeleteRole = (roleId) => {
      swal({
          title: 'Are you sure?',
          text: 'Once deleted, you will not be able to recover this item!',
          icon: 'warning',
          buttons: true,
          dangerMode: true,
      }).then((willDelete) => {
          if (willDelete) {
              http.delete(`/appoinemt-list-delete/${roleId}`)
                 .then(response => {
                     if(response.data.status !== 201){
                      setTableData(prevRoles => prevRoles.filter(data => data.id !== roleId));
                     }
                      
                      swal(response.data.msg, {
                          icon: response.data.alert,
                      });
                 })
                 .catch(error => {
                      swal('Oops! Something went wrong while deleting this item.', {
                          icon: 'error',
                      });
                 });
              swal('Poof! This item has been deleted!', {
                  icon: 'success',
              });
          } else {
              swal('This item is safe!');
          }
      });
  };

  function formatDate(dateString) {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }

  return (
    <div>
        <div className="main-content">
          <section className="section">
            <div className="section-body">
              <div className="row">
                <div className="col-12">
                  <div className="card card-primary">
                      <div className="card-body">
                          <div className="row d-flex">
                              <div className="mb-2">
                                  <Link to="/admin/pages/appoinment-list" className="btn btn-primary btn-sm mr-2">Pending List</Link>
                              </div>
                              <div className="mb-2">
                                  <Link to="/admin/pages/appoinment-list-confirmed"  className="btn border btn-sm mr-2">Appoinment Confirmed</Link>
                              </div>
                              <div className="mb-2">
                                  <Link to="/admin/pages/appoinment-list-today" className="btn border btn-sm mr-2">Appoinment Today</Link>
                              </div>
                              <div className="mb-2">
                                  <Link to="/admin/pages/appoinment-scheduled-confirm" className="btn border btn-sm mr-2">Scheduled Confirm</Link>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="card">
                    <div className="card-body">
                        <div class="d-flex justify-content-between mb-3">
                            <h5>Appoinment pending list</h5>
                            {/* <div class="text-end">
                                <Link to='/admin/pages/research-development-add' className="btn btn-primary btn-sm">Add New Research</Link>
                            </div> */}
                        </div>
                      <div className="table-responsive">
                        <table className="table table-striped" id="table-1" ref={tableRef}>
                          <thead>
                            <tr>
                              <th className="text-center">#</th>
                              <th>Name</th>
                              <th>Location</th>
                              <th>Number</th>
                              <th>Request Date</th>
                              <th>status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {tableData.map((data, index) => (
                              <tr key={data.id}>
                                <td>{index + 1}</td>
                                <td>{data.name}</td>
                                <td>{data.location}</td>
                                <td>{data.number}</td>
                                <td>{formatDate(data.created_at)}</td>
                                <td>
                                    {data.status === 1 && <span className='badge badge-primary'>Date Confirmed</span> }
                                    {data.status === 0 && <span className='badge badge-danger'>Not Confirmed</span> }
                                </td>
                                <td>
                                  {userPermission.includes('delete_appoinment') && (<Link to='' className="editbtn">
                                        <button className="btn btn-danger" onClick={() => handleDeleteRole(data.id)}>
                                            <i className="fas me-2 fa-trash text-white"></i>
                                        </button>
                                    </Link>
                                    )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
    </div>
  )
}

export default AppoinmentList